module.exports = function(locale, preview, filters) {
  return `
  fragment PageMetaDataFragment on PageMetaData {
  sys {
    id
  }
  __typename
  pageTitle
  metaTitle
  metaDescription
  metaKeywords
  openGraphPageTitle
  openGraphDescription
  ogImage:openGraphImage{
    url
  }
}
fragment ComponentWidthFragment on ComponentWidth {
  sys {
    id
  }
  name
  desktopComponentWidth
  smartphoneComponentWidth
  tabletComponentWidth
}
{
  contentPageCollection(limit: 1, locale: "${locale}", preview: ${preview}, where: {slug: "${filters.slug}"}) {
    items {
      sys{
        id
      }
      name
      slug
      breadcrumbTitle
      sitemapTitle
      title
      styles
      shortDescription
      isNewTemplate
      pageMetadata {
        ... on PageMetaData {
          ...PageMetaDataFragment
        }
      }
      backgroundImage {
        url
      }
      productIngredientsCollection(limit: 6) {
        items {
          sys {
            id
          }
          name
          ingredientsTitle
          ingredientsText
        }
      }
      faqSectionCollection(limit: 20) {
            items {
            title 
            question
            answer
            }
        }
      relatedCollectionsCollection(limit: 6) {
        items {
          sys {
            id
          }
          name
          title
          text
          styles
          primaryImageCollection {
            items {
              sys {
                id
              }
              name
              altText
              styles
               componentWidth {
                 ... on ComponentWidth {
                  ...ComponentWidthFragment
                  }
                }
              image {
                title
                description
                size
                url
                width
              }
            }
          }
          secondaryImageCollection {
            items {
              sys {
                id
              }
              name
              altText
              styles
               componentWidth {
                ... on ComponentWidth {
                  ...ComponentWidthFragment
                }
              }
              image {
                title
                description
                size
                url
                width
              }
            }
          }
          referencePageCollection(limit: 5) {
            items {
              __typename
              ... on ContentPage {
                slug
                name
                title
              }
            }
          }
        }
      }
      bannerImageCollection{
        items {
          sys {
            id
          }
          styles
          __typename
          name
          altText
          desktopImage {
            title
            url
            fileName
            contentType
          }
          tabletImage {
            title
            url
            fileName
            contentType
          }
          smartphoneImage {
            title
            url
            contentType
            fileName
          }
           componentWidth {
            ... on ComponentWidth {
              ...ComponentWidthFragment
            }
          }
        }
      }
      pageContentCollection {
        items {
          sys {
            id
          }
        }
      }
    }
    
  }
}`;
};
